
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {amountConversion, DataConversion} from "../../utils/util";
export default {
name: "ActivitySignupDetail",
directives: {
TransferDom
},
components: {
Cell,
Group,
GroupTitle,
XButton,
XInput,
XDialog
},
data(){
return {
dialogMsg: '',
showHideOnBlur:false,
shopId: this.$route.params.shopId,
actId: this.$route.params.actId,

mobile: this.$route.params.mobile,
signupData: {},
actData:{},
confirmText: "确认",
confirmDisabled: false,
confirmRemark: "",
completeText: "完成",
completeDisabled: false,
completeRemark: "",
}
},
created(){
this.initPageData();
},
methods:{
promptMsg(msg) {
let _this = this;
_this.dialogMsg = msg;
_this.showHideOnBlur = true;
setTimeout(function(){
_this.showHideOnBlur = false;
},1500);
},
initPageData(){
this.getActInfo();
this.getSignupInfo();
},
getStatusName(status) {
if (status==0) {
return "未提交";
} else if (status==1) {
return "已提交";
} else if (status==2) {
return "已成功";
} else if (status==3) {
return "已失败";
} else if (status==4) {
return "已核销";
} else {
return "未知";
}
},
getActInfo(){
let _this = this;
_this.axios.post('/v1/shop/'+_this.shopId+'/act/GET_OFFLINE_ACT_LIST', {     //    tx-bnb/act/GET_OFFLINE_ACT_LIST
"actType": 1
}).then(function (response) {
if (response.data.code == 0) {
let acts = response.data.data.rows;
for (var i=0; i<acts.length; i++) {
if (acts[i].id == _this.actId) {
_this.actData = acts[i];
break;
};
}
}
}).catch(function (response) {
console.log(response);
});
},
getSignupInfo(){
let _this = this;
_this.axios.post('/v1/shop/'+_this.shopId+'/act/GET_OFFLINE_ACT_SIGNUP_INFO', {
"actId": _this.actId,
"mobile": _this.mobile
}).then(function (response) {
if (response.data.code == 0) {
_this.signupData = response.data.data
}
}).catch(function (response) {
console.log(response);
});
},

btnConsume() {
let _this = this;
if (_this.signupData.status!=2) {
_this.promptMsg("报名记录尚未审核通过，或已核销");
return;
}
_this.axios.post('/v1/shop/'+_this.shopId+'/act/UPDATE_ACT_OFFLINE_SIGNUP_STATUS', {
"id": _this.signupData.id,
"status": 4
}).then(function (response) {
if (response.data.code == 0) {
_this.promptMsg("操作成功！");
_this.signupData.status = 4;
} else {
_this.promptMsg(response.data.msg);
}
}).catch(function (response) {
console.log(response);
});
},

btnConfirm(confirmOK) {
let _this = this;
if (_this.signupData.status!=1) {
_this.promptMsg("报名记录非提交状态，不能审核");
return;
}
let status = confirmOK==true?2:3;
_this.axios.post('/v1/shop/'+_this.shopId+'/act/UPDATE_ACT_OFFLINE_SIGNUP_STATUS', {
"id": _this.signupData.id,
"status": status
}).then(function (response) {
if (response.data.code == 0) {
_this.promptMsg("操作成功！");
_this.signupData.status = status;
} else {
_this.promptMsg(response.data.msg);
}
}).catch(function (response) {
console.log(response);
});
},
}
}



// WEBPACK FOOTER //
// ./src/components/activity/ActivitySignupDetail.vue